export const LOCATION_CHANGE = 'LOCATION_CHANGE';

type LocationLike = {
	pathname: string;
	search?: string;
	hash?: string;
};

type RouterActionType = 'PUSH' | 'POP' | 'REPLACE';

export const locationChange = (
	location: LocationLike,
	action: RouterActionType = 'PUSH'
): { type: string; payload: { location: LocationLike; action: RouterActionType } } => ({
	type: LOCATION_CHANGE,
	payload: {
		location,
		action,
	},
});
